export default __webpack_public_path__ + "img/caret.c2368450.svg";